import React, {Component} from 'react';
import Typist from 'react-typist';

export default class TypewriterTextBksp extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return <div className="typist">
      <Typist
        avgTypingDelay={0}
      >
        {this.props.text}
        {/* {!this.props.back ? <Typist.Backspace count={4} delay={0} /> : <></> } */}
      </Typist>
    </div>;
  }
}